import AboutBlurb from './atoms/AboutBlurb';
import { Hatch, Burst } from './atoms/Decor';
var data = require('./data/about');

export default function About() {
    return (
        <section id="about" className="about-section px-4 md:px-10 pb-20 pt-20 md:pt-28">
            <div className="about-inner">

                <header className="reveal about-header">
                    <h1 id="about-heading">about</h1>
                    <Burst className="about-burst" />
                </header>

                <div className="about-list">
                    {data.map((point, idx) => (
                        <div key={point.title}>
                            <AboutBlurb
                                title={point.title}
                                subtitle={point.subtitle}
                                dates={point.dates}
                                description={point.description}
                            />
                            {idx === 1 && (
                                <div className="reveal about-divider">
                                    <Hatch className="about-hatch" />
                                </div>
                            )}
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
}
